function apiHost () {
    const debug = process.env.NODE_ENV !== 'production'
    const prefixUrl = location.hostname;
    let defaultUrl = ''
    if (!debug) {
      if (prefixUrl === 'web.hffss.com'){
        defaultUrl = 'https://api.raise.hffss.com';
      } else {
        defaultUrl = 'https://api.raise.hffss.com';
      }
    } else {
      defaultUrl = 'https://api.raise.hffss.com'
    }
    return defaultUrl
  }
  export const apiUrl = apiHost()
  